import { render, staticRenderFns } from "./ImgSlideParts.vue?vue&type=template&id=6c7aa85a&scoped=true"
import script from "./ImgSlideParts.vue?vue&type=script&lang=ts"
export * from "./ImgSlideParts.vue?vue&type=script&lang=ts"
import style0 from "./ImgSlideParts.vue?vue&type=style&index=0&id=6c7aa85a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c7aa85a",
  null
  
)

export default component.exports